<template>
  <div>
    <h2>Registrierungsanfragen</h2><br>
    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>Optionen</th>
        <th>Nachname</th>
        <th>Vorname</th>
        <th>E-Mail</th>
        <!--        <th>Handynummer</th>-->
      </tr>
      </thead>
    </table>

    <div>
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
/* global $ */

export default {
  name: 'UserRegisterRequests',
  props: ['id'],
  data () {
    return {
      // eslint-disable-next-line no-undef
      tableId: (this.$props.id !== undefined) ? 'dTable_' + this.$func.uuid() + '_' + this.$props.id : 'dTable_' + this.$func.uuid()
    }
  },
  computed: {},
  async mounted () {
    await this.$store.dispatch('selectize/fetchSkills')

    var store = (this.$store)
    var router = this.$router
    var tableId = this.tableId
    var self = this

    this.$func.loadDatatable(
      () => $(document).ready(function () {
        const ouOpts = {
          plugins: ['remove_button'],
          maxItems: null,
          valueField: 'id',
          searchField: ['sName'],
          placeholder: 'Standort auswählen ...',
          preload: true,
          options: [],
          sortField: [{
            field: 'sName',
            direction: 'asc'
          }, {
            field: '$score'
          }],
          create: false,
          render: {
            option: function (data, escape) {
              return '<div>' + escape(data.sName) + '</div>'
            },
            item: function (item, escape) {
              return '<div>' + escape(item.sName) + '</div>'
            }
          },
          load: function (query, callback) {
            callback(store.getters.getLocations)
          }
        }

        const ouOptSingle = {
          plugins: [],
          maxItems: 1,
          valueField: 'id',
          searchField: ['sName'],
          placeholder: 'Standort auswählen ...',
          preload: true,
          options: [],
          sortField: [{
            field: 'sName',
            direction: 'asc'
          }, {
            field: '$score'
          }],
          create: false,
          render: {
            option: function (data, escape) {
              return '<div>' + escape(data.sName) + '</div>'
            },
            item: function (item, escape) {
              return '<div>' + escape(item.sName) + '</div>'
            }
          },
          load: function (query, callback) {
            callback(store.getters.getLocations)
          }
        }

        const skills = {
          plugins: ['remove_button'],
          maxItems: null,
          valueField: 'id',
          searchField: ['sBezeichnung'],
          placeholder: 'Fahrerlaubnisklasse auswählen ...',
          preload: true,
          options: [],
          sortField: [{
            field: 'sBezeichnung',
            direction: 'asc'
          }, {
            field: '$score'
          }],
          create: false,
          render: {
            option: function (data, escape) {
              return '<div>' + escape(data.sBezeichnung) + '</div>'
            },
            item: function (item, escape) {
              return '<div>' + escape(item.sBezeichnung) + '</div>'
            }
          },
          load: function (query, callback) {
            callback(store.getters['selectize/getSkills'])
          }
        }

        // eslint-disable-next-line no-undef
        var editor = new $.fn.dataTable.Editor({
          ajax: {
            create: self.$func.addAuth({
              type: 'POST',
              url: '/user/'
            }),
            edit: self.$func.addAuth({
              type: 'PUT',
              url: '/user/_id_/'
            }),
            remove: self.$func.addAuth({
              type: 'DELETE',
              url: '/user/_id_/',
              deleteBody: false
            })
          },
          idSrc: 'id',
          table: '#' + tableId,
          fields: [{
            label: 'Aktiv:',
            name: 'bRegProcess',
            type: 'radio',
            options: [
              {
                label: 'Ja',
                value: 0
              },
              {
                label: 'Nein',
                value: 1
              }
            ]
          }, {
            label: 'Nachname:',
            name: 'sLastname'
          }, {
            label: 'Vorname:',
            name: 'sFirstname'
          }, {
            label: 'Fahrerlaubnisklassen:',
            name: 'oSkill_arr',
            type: 'selectize',
            closeAfterSelect: true,
            opts: skills
          }, {
            label: 'E-Mail Adresse:',
            name: 'sEmail'
          }, {
            label: 'E-Mail-Adresse dienstlich:',
            name: 'sEmailDienstlich'
          }, /* {
            label: 'Handynummer:',
            name: 'sMobile'
          }, */ {
            label: 'Standorte:',
            name: 'oOu_arr',
            type: 'selectize',
            closeAfterSelect: true,
            opts: ouOpts
          }, {
            label: 'Abrechnungsstandort:',
            name: 'oInvoiceOu',
            type: 'selectize',
            closeAfterSelect: true,
            opts: ouOptSingle
          }
          ]
        })

        $('#' + tableId).DataTable({
          dom: 'BfQrtip', // BUTTON/FIND/PROCESSING/TABLE/INFO/PAGING
          ajax: self.$func.addAuth({
            url: '/user/requests/',
            type: 'GET'
          }),
          scrollX: true,
          scrollCollapse: true,
          order: [[1, 'asc']],
          rowId: 'id',
          columns: [
            {
              class: 'center not-export-col w100',
              data: null,
              render: function (data, type, row) {
                // eslint-disable-next-line no-unused-vars
                var check = '<i title="Freischalten" class="dt-check fas fa-check fa-lg pointer text-secondary"></i>'

                return check
              }
            },
            {
              class: 'center',
              data: 'sLastname'
            },
            {
              class: 'center',
              data: 'sFirstname'
            },
            {
              class: 'center',
              data: 'sEmail'
            }
            /* {
              class: 'center',
              data: 'sMobile'
            } */
          ],
          initComplete: function (settings, json) {
            // $('#' + tableId).DataTable().searchPanes.rebuildPane()
          },
          buttons: self.$func.addDefaultButtons([
            {
              extend: 'edit',
              editor: editor
            },
            {
              extend: 'remove',
              editor: editor
            }
          ])
        })

        $('#' + tableId).on('click', '.dt-rechte', function (e) {
          e.preventDefault()
          var tr = $(this).closest('tr')
          var row = $('#' + tableId).DataTable().row(tr)
          var id = row.data().id

          router.push({
            name: 'userpermissions',
            params: {
              id: id,
              context: 'userregisterrequests',
              payload: row.data()
            }
          })
        })

        $('#' + tableId + ' tbody').on('dblclick', 'tr', function () {
          editor
            .edit(this)
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons([{
              label: 'Abbruch',
              className: 'btn btn-secondary mx-1',
              fn: function () {
                editor.close()
              }
            }, {
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            }])

          editor.field('bRegProcess').show()
        })

        $('#' + tableId).on('click', '.dt-check', function (e) {
          editor.field('bRegProcess').hide()
          editor
            .edit($(this).closest('tr'))
            .title('Benutzer freischalten')
            .buttons([{
              label: '<div style="text-align: center; height: 3rem; line-height: 3rem;">Abbruch</div>',
              className: 'btn btn-secondary mx-1',
              fn: function () {
                editor.close()
              }
            }, {
              label: '<div style="text-align: center; height: 3rem; line-height: 3rem;">Freischalten</div>',
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            }])

          editor.field('bRegProcess').hide()
          editor.set('bRegProcess', 0)
        })

        editor.on('submitSuccess', function (e, json, data, action) {
          if (action == 'edit' && (json.data[0].bRegProcess == 0)) {
            $('#' + tableId).DataTable().row('#' + json.data[0].id).remove().draw()
          }
        })

        editor.on('preOpen', function (e, mode, action) {
          editor.field('oInvoiceOu').set(store.getters.getLocation.id)

          if (store.getters.getLocations.length === 1) {
            editor.field('oOu_arr').hide()
            editor.field('oInvoiceOu').hide()
          } else {
            editor.field('oOu_arr').show()
            editor.field('oInvoiceOu').show()
          }
        })
      }))
  }
}
</script>
<style>

</style>
